'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgManual } from '@common/icon';
import { CustomLink } from '@/app/_components/CustomLink';
import { CartIconLink } from '@/app/donation/_components/CartIconLink';
import { PageNavigation } from '@/components/client';
import { CenteredDetailTemplate } from '@/components/template/CenteredDetailTemplate';
import { DONATION_ROUTES } from '@/constants';
import { ImageSection } from './ImageSection';
const CONTENTS_IMAGE_PREFIX = 'https://cdn.welfarehello.com/static/donation-event-galaxy-watch-';
export const GalaxyWatchPage = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CartIconLink />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PageNavigation donationHomeButton={true} isNotUsedHomeButton={true}>{t0}<CustomLink href={DONATION_ROUTES.GUIDE.pathname} aria-label={"\uAC00\uC774\uB4DC \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"}><SvgManual className="size-24 text-Gray-900" /></CustomLink></PageNavigation>;
    t2 = <h1 className="sr-only">8월, 웰로에서 기부하면 갤워치8 기브 합니다</h1>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ImageSection url={`${CONTENTS_IMAGE_PREFIX}1.png`} title={"8\uC6D4, \uC6F0\uB85C\uC5D0\uC11C \uAE30\uBD80\uD558\uBA74 \uAC24\uC6CC\uCE588 \uAE30\uBE0C \uD569\uB2C8\uB2E4"} description={["8\uC6D4, \uC6F0\uB85C\uC5D0\uC11C \uAE30\uBD80\uD558\uBA74 \uAC24\uC6CC\uCE588 \uAE30\uBE0C \uD569\uB2C8\uB2E4"]} alt={"8\uC6D4, \uC6F0\uB85C\uC5D0\uC11C \uAE30\uBD80\uD558\uBA74 \uAC24\uC6CC\uCE588 \uAE30\uBE0C \uD569\uB2C8\uB2E4"} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ImageSection url={`${CONTENTS_IMAGE_PREFIX}2.png`} title={"\uC6F0\uB85C \uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80\uC790\uB2D8\uB4E4\uC744 \uC704\uD55C \uAE30\uAC04 \uD55C\uC815 \uD2B9\uBCC4 \uC120\uBB3C!"} description={["\uC774\uBCA4\uD2B8 \uAE30\uAC04 : 8\uC6D4 8\uC77C ~ 8\uC6D4 14\uC77C"]} alt={"\uC6F0\uB85C \uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80\uC790\uB2D8\uB4E4\uC744 \uC704\uD55C \uAE30\uAC04 \uD55C\uC815 \uD2B9\uBCC4 \uC120\uBB3C!"} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ImageSection url={`${CONTENTS_IMAGE_PREFIX}3.png`} title={"\uAE30\uBD80\uD558\uBA74 \uC6F0\uB85C\uAC00 \uC3DC\uB2E4!"} description={["\uCD1D 6\uBA85 \uACBD\uD488 \uCD94\uCCA8 \uD574\uB2F9 \uC774\uBCA4\uD2B8 \uAE30\uAC04\uC5D0 10\uB9CC\uC6D0 \uC774\uC0C1 \uC6F0\uB85C \uC2E0\uADDC \uAE30\uBD80\uC790 \uB300\uC0C1"]} alt={"\uAE30\uBD80\uD558\uBA74 \uC6F0\uB85C\uAC00 \uC3DC\uB2E4!"} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ImageSection url={`${CONTENTS_IMAGE_PREFIX}4.png`} title={"\uAE30\uBCF8 \uAE30\uBD80 \uD61C\uD0DD"} description={["\uB0B4 \uAC70\uC8FC\uC9C0 \uC678 \uC9C0\uC5ED\uC5D0 10\uB9CC \uC6D0 \uAE30\uBD80 \uC2DC, \uC138\uC561 \uACF5\uC81C 10\uB9CC \uC6D0 \uD504\uB9AC\uBBF8\uC5B4 \uB2F5\uB840\uD488 \uC81C\uACF5"]} alt={"\uAE30\uBCF8 \uAE30\uBD80 \uD61C\uD0DD"} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 className="mb-16 text-center font-700 text-Gray-300 typo-body2">웰로 이벤트 유의사항</h2>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <section className="bg-Gray-700 px-30 py-60">{t7}<ul className="pl-22 text-Gray-550 typo-caption1"><li className="list-disc">본 이벤트는 ㈜웰로가 주관하며, 고향사랑기부제 참여 유도 및 공유 활성화를 위한 신규 기부자들을 위한 이벤트입니다.</li><li className="list-disc">기존에 10만 원 이상 기부를 완료한 회원 또는 동일 이벤트 당첨 이력이 있는 경우, 참여 및 리워드 지급 대상에서 제외됩니다.</li><li className="list-disc">본 이벤트는 웰로를 통해 지역 구분 없이 10만 원 이상 실제 기부를 완료한 회원을 대상으로 하며, 1인 1회만 참여 및 수령이 가능합니다.</li><li className="list-disc">선착순 지원금은 선착순으로 소진되며, 조기 마감 시 별도 공지 없이 종료될 수 있습니다.</li><li className="list-disc">선착순 지원금 및 리워드는 계정 기준으로 지급되며, 동일 명의/기기/연락처로 중복 참여 시 지급이 제한될 수 있습니다.</li><li className="list-disc">이벤트 리워드는 회원 정보(휴대폰 번호 및 계정 정보) 기준으로 지급되며, 등록 오류로 인한 미지급에 대한 별도 보상은 제공되지 않습니다.</li><li className="list-disc">본 이벤트 경품은 제세공과금(22%) 대상이며, 해당 금액은 당첨자 부담입니다.</li><li className="list-disc">제세공과금 대리 납부를 위해 당첨자의 개인정보(성명, 생년월일, 주민등록번호, 주소 등)를 수집하며, 정보 제공을 거부할 경우 당첨이 취소될 수 있습니다.</li><li className="list-disc">본 이벤트 경품 지급 시, 신분증 또는 본인 확인이 가능한 증빙 서류 제출을 요청할 수 있으며, 본인 확인이 불가능하거나 제세공과금 미납 시 경품 지급이 제한됩니다.</li><li className="list-disc">본 이벤트는 내부 사정 또는 외부 제휴사의 요청으로 사전 고지 없이 변경되거나 중단될 수 있습니다.</li></ul></section>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CenteredDetailTemplate><article className="flex flex-col">{t1}{t2}{t3}{t4}{t5}{t6}{t8}<footer className="sticky bottom-0 mt-auto w-full bg-Gray-white px-20 py-12"><Button asChild={true} theme="sub-fill" dimensions="H56" disabled={true} className="bg-[#EBA36D] text-Gray-white hover:bg-[#EBA36D]"><CustomLink href={DONATION_ROUTES.GIFTS.pathname + "?utm_source=wello_event&utm_medium=button&utm_campaign=event_0808&utm_content=event_0808"} aria-label={"\uB2F5\uB840\uD488 \uBAA9\uB85D \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"} className="w-full" onClick={_temp}>이벤트 종료</CustomLink></Button></footer></article></CenteredDetailTemplate>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
};
function _temp(e) {
  return e.preventDefault();
}